module.exports = "<div>\n    <div class=\"h7 order-summary-count-instructions ut-receipt-displayCountOfItems\">\n        <span class=\"order-summary-count-instructions_items-count\">{{ctrl.itemCountMessage}}</span>\n        <span ng-if=\"ctrl.specialInstructionsTag\" class=\"ut-special-instructions-tag\"> - {{ctrl.specialInstructionsTag}}</span>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/receipt/sections/orderSummaryCountAndInstructionsTag.html
// module id = 791
// module chunks = 0